import {Injectable} from '@angular/core';
import {HttpService} from "../../core/services/http.service";
import {Observable, of} from "rxjs";
import {ConfirmationModel} from "../../core/models/confirmation.model";
import {CommentModel} from "../../core/models/comment.model";
import {environment} from '../../../environments/environment';
import {TimeSlotsModel} from "../../core/models/time-slots.model";
import {AppointmentModel} from "../../core/models/appointment.model";
import {TimeSlotModel} from "../../core/models/time-slot.model";
import {SettingsModel} from "../../core/models/settings.model";

const API_URL = environment.apiUrl;

@Injectable()
export class SettingsService {

  constructor(private httpService: HttpService) {
  }

  getSettings(countryCode: string): Observable<SettingsModel> {
    return this.httpService.get<any>(API_URL + `/settings/${countryCode}`);
  }
}
